import React from 'react'

const CountdownItem = ({ time, label, unit, showDateLabels }) => {
  return (
    <>
      <div className={`countdown-item countdown-item-${unit}`}>
        <span className="countdown-item-time">{time}</span>
        {showDateLabels && (
          <span className="countdown-item-label">{label}</span>
        )}
      </div>
      {unit !== 'seconds' && <p className={`divider divider-${unit}`}>:</p>}
    </>
  )
}

export default CountdownItem
